import React, {useState} from "react";
import {BsrsFormFeature} from "../BsrsFormFeature";
import {BsrsResultFeature} from "../BsrsResultFeature";
import {BsrsInfoFeature} from "../BsrsInfoFeature";

enum MODE_TYPE {
  FORM = 'form',
  VIEW = 'view',
  INFO = 'info',
}

export const BsrsFlowFeature = () => {
  const [mode, setMode] = useState<MODE_TYPE>(MODE_TYPE.FORM);
  const [answers, setAnswers] = useState<number[]>([0, 0, 0, 0, 0, 0]);
  const [score, setScore] = useState<number>(0);

  return (
    <React.Fragment>
      {mode === MODE_TYPE.FORM ? (
        <BsrsFormFeature
          onSubmittedForm={() => setMode(MODE_TYPE.VIEW)}
          answers={answers}
          score={score}
          onChangeAnswers={(tempAnswers: number[]) => setAnswers(tempAnswers)}
          onChangeScore={(tempScore: number) => setScore(tempScore)}
        />
      ) : null}
      {mode === MODE_TYPE.VIEW ? (
        <BsrsResultFeature
          score={score}
          answers={answers}
          onSubmittedForm={() => setMode(MODE_TYPE.INFO)}
        />
      ) : null}
      {mode === MODE_TYPE.INFO ? <BsrsInfoFeature/> : null}
    </React.Fragment>
  )
}